import React, { useEffect, useState } from "react";
import { Box, Text, Image, Flex, VStack, HStack, Button, Tag, Spinner, useToast } from "@chakra-ui/react";
import { BASE_URL } from "../../../../Globalapi/Globalapi";

const StudentProfileCard = () => {
  const [studentData, setStudentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const toast = useToast();

  useEffect(() => {
    const userId = sessionStorage.getItem("user_id"); // Assuming user_id is stored in session
    const fetchStudentData = async () => {
      try {
        const response = await fetch(`${BASE_URL}/student/student_profile.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ pass: userId }),
        });
        const data = await response.json();

        if (data.success) {
          setStudentData(data.data);
        } else {
          setError("Failed to fetch student data.");
          toast({
            title: "Error",
            description: "Failed to fetch student data.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
      } catch (err) {
        setError("An error occurred while fetching data.");
        toast({
          title: "Error",
          description: "An error occurred while fetching data.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchStudentData();
  }, [toast]);

  if (loading) return <Spinner size="xl" mt="20" />;
  if (error) return <Text color="red.500">{error}</Text>;

  return (
    <Box width="560px" p={6} borderWidth="1px" borderRadius="lg" boxShadow="md" bg="white">
      {/* Profile Section */}
      <Flex align="center" mb={6}>
        <Box position="relative" mr={4}>
          <Image
            src={studentData.image_url || 'https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg'}
            alt="Profile"
            boxSize="48px"
            borderRadius="full"
            onError={(e) => {
              e.target.src = 'https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg';
          }}
          />
        </Box>
        <Box>
          <Text fontSize="lg" fontWeight="medium">
            {studentData.name}
          </Text>

        </Box>
      </Flex>

      {/* Basic Information Section */}
      <VStack align="start" spacing={4}>
        <Text fontWeight="medium" fontSize="md" color="gray.700">
          Basic Information
        </Text>
        <VStack spacing={3} align="stretch" width="full">
          {[
            { label: "Username", value: studentData.username },
            { label: "Gender", value: studentData.gender },
            { label: "Date Of Birth", value: studentData.date_of_birth },
            { label: "Blood Group", value: studentData.blood_group },
            { label: "Medium", value: studentData.medium },
            { label: "Guardian", value: studentData.guardian_name },
            { label: "Class", value: studentData.class_name},
            { label: "Section", value: studentData.section},
            { label: "Subjects", value: studentData.subjects.split(",").join(", ") },
          ].map((item, index) => (
            <Flex key={index} justify="space-between" fontSize="sm">
              <Text color="gray.600">{item.label}</Text>
              <Text color="gray.900">{item.value}</Text>
            </Flex>
          ))}
        </VStack>
      </VStack>

      {/* Add Fees Button */}
      {/* <Button
        mt={6}
        colorScheme="blue"
        width="full"
        _hover={{ bg: "blue.700" }}
        _focus={{ outline: "none" }}
      >
        Pay Fees
      </Button> */}
    </Box>
  );
};

export default StudentProfileCard;
